//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import LazyHydrate from "vue-lazy-hydration";
import { checkIfUrlIsExternal } from "~/helpers/validation-utils";

export default Vue.extend({
  name: "Hero",
  components: {
    LazyHydrate,
    SfHero: () => import("~/themes/fiskarsMoominDefault/components/components/organisms/SfHero/SfHero.vue")
  },
  methods: {
    getHeroBackground(item) {
      return item?.background?.background?.selectionValues[0]?.key ? item?.background?.background?.selectionValues[0]?.key : 'var(--c-secondary)';
    },
    checkAndReturnLink(link) {
      if(!link) return "/";

      if(checkIfUrlIsExternal(link)) {
        return link;
      } else {
        return this.localePath(link);
      }
    }
  },
  props: {
    documents: {
      type: Object,
      default: () => {},
    },
    properties: {
      type: Object,
    },
    autoPlay: {
      type: Number,
      default: 0
    }
  },
});
